import { ApiService } from './api.service';
import { CustomCompetency, CreateCustomCompetency, UpdateCustomCompetency, CustomCompetencyBoxplot, AddUpdateCustomCompetencyBoxplot } from '@/models/competency/competency';
import { Empty } from '@/models/core/empty';

class CustomCompetencyService extends ApiService {
  constructor() {
    super();
  }

  fetch(): Promise<CustomCompetency[]> {
    return this.getList(CustomCompetency, 'customCompetencies', {});
  }

  createCustomCompetency(params: CreateCustomCompetency): Promise<CustomCompetency> {
    return this.post(CustomCompetency, 'customCompetencies', params);
  }

  updateCustomCompetency(params: UpdateCustomCompetency): Promise<CustomCompetency> {
    return this.put(CustomCompetency, `customCompetencies/${params.id}`, params);
  }

  deleteCustomCompetency(id: number): Promise<Empty> {
    return this.delete(`customCompetencies/${id}`, {});
  }

  fetchCustomCompetencyBoxplot(): Promise<CustomCompetencyBoxplot> {
    return this.get(CustomCompetencyBoxplot, 'customAnalyses/boxplot', {});
  }

  addUpdateCustomCompetencyBoxplot(params: AddUpdateCustomCompetencyBoxplot): Promise<Empty> {
    return this.post(Empty, 'customAnalyses/boxplot', params);
  }

  fetchCustomCompetencyBoxplotForGraph(): Promise<CustomCompetency[]> {
    return this.getList(CustomCompetency, 'customAnalyses/graph/boxplot', {});
  }
}

export const customCompetencyService = new CustomCompetencyService();
